<template>
  <div
    class="grid grid-cols-1 w-full md:grid-cols-12 gap-[30px] md:gap-[65px] mt-[30px]"
  >
    <div class="flex justify-center md:justify-start md:col-span-5">
      <BikeModal class="max-w-[400px]" />
    </div>
    <div class="flex flex-col justify-start md:col-span-7">
      <h3
        class="my-0 text-[20px] font-ff-good-pro-cond font-medium !leading-[26px] md:text-[24px] md:!leading-[34px] text-start text-black"
      >
        {{ $t("common.choose_bike_options") }}
      </h3>
      <div class="mt-6">
        <label
          for="height"
          class="block text-sm font-bold leading-6 text-secondary uppercase font-ff-good-pro-cond tracking-[0.14px]"
          v-text="$t('common.bike_model')"
        />
        <div class="flex items-center gap-2 mt-1 w-full md:max-w-[450px]">
          <ProductSelector
            :options="calculateBikeSizeStore.bikeModals"
            name="bike_modal"
            value-field="id"
            v-model="product"
            unique-key="id"
            :placeholder="`${$t('common.select_here')}...`"
            :errorMessage="errorsMessage"
            :hasError="!!errorsMessage"
            label="name"
            @input="errorsMessage = null"
            parent-container="w-full"
          >
            <template #option="{ option }">
              <div class="flex items-center text">
                <span class="text-base">{{ option.name }}</span>
              </div>
            </template>
          </ProductSelector>
        </div>
      </div>
      <div class="flex w-full gap-2 mt-10 md:w-auto">
        <Btn
          type="button"
          size="lg"
          block
          :rounded="false"
          class="w-full md:!w-auto uppercase rounded-md px-[30px]"
          color="secondary"
          v-text="$t('common.back')"
          @click="goBack"
        />
        <Btn
          type="button"
          size="lg"
          block
          :rounded="false"
          class="w-full md:!w-auto uppercase rounded-md px-[30px]"
          color="primary"
          v-text="$t('common.next')"
          @click="goNext"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import Tips from "~/assets/svg/heroicons/tips.svg?component";
import BikeModal from "~/assets/svg/calculate-size/bbike-model.svg?component";
import { useCalculateBikeSizeStore } from "~/store/calculatebikesize";
import { useTranslation } from "i18next-vue";
import { useMainStore } from "~/store";

const calculateBikeSizeStore = useCalculateBikeSizeStore();

const { t } = useTranslation();
const emit = defineEmits();

const gender = ref(calculateBikeSizeStore.form.gender);
const errorsMessage = ref(null);
const product = ref(calculateBikeSizeStore.form.product_id);
const unit = ref(calculateBikeSizeStore.form.unit);

function goNext() {
  if (!product.value) {
    errorsMessage.value = t("common.field_required", {
      attribute: t("common.bike_model"),
      interpolation: { prefix: "[:", suffix: "]" },
    });
    return false;
  }
  calculateBikeSizeStore.updateForm("product_id", product.value);
  emit("next", "height");
}
function goBack() {
  emit("back", "gender");
  if (product.value) {
    calculateBikeSizeStore.updateForm("product_id", product.value);
  }
}
</script>